import { Box, Container, Paper } from "@mui/material";
import useGetLogo from "src/components/logo/hooks/use-logo";
import { useTheme } from "@mui/material/styles";
import { WORDPRESS, WORDPRESS_HOME } from "src/config";
import { Link as RouterLink } from "react-router-dom";
import { Link } from "react-router-dom";

const AuthLayout = ({ register, children }) => {
  const logo = useGetLogo();
  const { palette } = useTheme();

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        background: `linear-gradient(to right, ${palette.primary.lighter}, ${palette.secondary.lighter})`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        py: { xs: 8, md: 12 },
      }}
    >
      <Container maxWidth={register === true ? "sm" : "xs"} sx={{ px: 0 }}>
        <Paper
          elevation={6}
          sx={{
            px: 4,
            py: 5,
            borderRadius: 4,
            textAlign: "center",
            boxShadow: "0 8px 24px rgba(0, 0, 0, 0.1)",
            backdropFilter: "blur(10px)",
            // backgroundColor: "rgba(255,255,255,0.9)",
            backgroundColor:"background.paper"
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mb: 4,
              animation: "fadeIn 1s ease-out",
            }}
          >
            <a href={WORDPRESS_HOME} component={RouterLink}>
              <img
                src={logo}
                alt="Logo"
                style={{
                  width: "150px",
                  height: "auto",
                  transition: "transform 0.3s ease-in-out",
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.transform = "scale(1.1)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.transform = "scale(1.0)")
                }
              />
            </a>
          </Box>

          {children}
        </Paper>
      </Container>

      {/* Keyframes for fadeIn */}
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </Box>
  );
};

export default AuthLayout;
